import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, createBlock as _createBlock, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "delivery-charge-root" };
const _hoisted_2 = { class: "contents-title-text d-flex align-center" };
const _hoisted_3 = { class: "d-flex week-checkbox" };
const _hoisted_4 = { class: "mt-1" };
const _hoisted_5 = { class: "brg-error-message" };
const _hoisted_6 = { class: "brg-error-message" };
const _hoisted_7 = { class: "d-flex" };
const _hoisted_8 = {
    key: 0,
    class: "checkbox-inline-label"
};
const _hoisted_9 = { class: "mt-1" };
const _hoisted_10 = { class: "submit-row d-flex" };
import { computed, nextTick, onUnmounted, ref, watch, } from 'vue';
import InputRow from '@/components/Form/InputRow.vue';
import RangeInput from '@/components/Form/RangeInput.vue';
import { initAutoLc } from '@/locales/ko/views/delivery_charge_dialog';
import { autoLcCommon as initAutoLcCommon } from '@/locales/ko/common';
import { koWeekObject } from '@/constants/week';
import DeliveryChargeAreaControl from '@/views/Dialog/DeliveryChargeAreaControlDialog/index.vue';
import { deliveryChargeActionType } from '@/vuex-store/delivery-charge-dialog/actions';
import vuexStore from '@/vuex-store';
import { deliveryChargeTypeName } from '@/constants/storeManagement/deliveryChargeDialog';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import { i18n } from '@/locales';
import { setLimitedByteTextSimple } from '@/utils';
import { addComma, deleteComma } from '@/utils/number';
import { alertActionType } from '@/vuex-store/alert/actions';
import { createDeliveryChargeFormRule } from '@/form/form-rules/deliveryCharge';
import { validationLimitingValue } from '@/constants/validationLimitingValue';
import { deliveryChargeMutationType } from '@/vuex-store/delivery-charge-dialog/mutations';
import { AxiosError } from 'axios';
import AxiosResponse from '@/error/AxiosResponse';
import { BusinessError } from '@/error';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DeliveryChargeForm',
    setup(__props) {
        const lc = initAutoLc();
        const lcRadio = initAutoLc('form_area.delivery_charge_type_radio.');
        const lcDialog = initAutoLc('dialog_cancel_edit.');
        const lcCommon = initAutoLcCommon();
        const distanceOrder = ref(undefined);
        const addressJibunOrder = ref(undefined);
        const formRef = ref(null);
        const formRule = createDeliveryChargeFormRule();
        const isEdit = computed(() => vuexStore.state.deliveryChargeDialog.isEdit);
        const selectedItem = computed(() => vuexStore.state.deliveryChargeDialog.selectedItem);
        const isJibunType = computed(() => vuexStore.state.deliveryChargeDialog.formData.type === deliveryChargeTypeName.LOT_NUMBER_ADDRESS);
        const formData = computed(() => vuexStore.state.deliveryChargeDialog.formData);
        // 구분 선택값
        const deliveryChargeRadio = ref([
            {
                label: lcRadio('distance'),
                value: deliveryChargeTypeName.DISTANCE,
            },
            {
                label: lcRadio('jibun'),
                value: deliveryChargeTypeName.LOT_NUMBER_ADDRESS,
            },
            {
                label: lcRadio('area'),
                value: deliveryChargeTypeName.AREA,
            },
        ]);
        /**
         * 변경 확인창
         */
        const confirm = () => vuexStore.dispatch(alertActionType.confirm, {
            headerTitle: lcDialog('title'),
            bodyContent: i18n.t('common.confirm_before_cancel'),
            btnConfig: [
                {
                    text: 'cancel',
                    cssClass: 'outlined info',
                },
                {
                    text: 'ok',
                    cssClass: 'danger',
                },
            ],
        });
        /**
         * submit 핸들러
         * @param submitData
         */
        const handleSubmitForm = async (submitData) => {
            const result = await submitData;
            if (!result.valid) {
                return;
            }
            try {
                await vuexStore.dispatch(deliveryChargeActionType.submit);
                vuexStore.dispatch(snackbarActionType.showSuccess, i18n.t('common.success'));
                vuexStore.dispatch(deliveryChargeActionType.getDeliveryChargeList);
                vuexStore.dispatch(deliveryChargeActionType.setOriginForm);
            }
            catch (error) {
                if (error instanceof BusinessError) {
                    vuexStore.dispatch(snackbarActionType.showError, error.message);
                }
                if (error instanceof AxiosResponse) {
                    vuexStore.dispatch(snackbarActionType.showError, error.data.error.message);
                }
                if (error instanceof AxiosError) {
                    vuexStore.dispatch(snackbarActionType.showError, {
                        message: error.response?.data.error.message,
                    });
                }
            }
        };
        /**
         * 구역선택 버튼 클릭 핸들러
         */
        const handleClickSelectAreaBtn = () => {
            vuexStore.dispatch(deliveryChargeActionType.areaDialogOpen);
        };
        /**
         * 수정 취소 핸들러
         */
        const handleClickCancel = async () => {
            try {
                await vuexStore.dispatch(deliveryChargeActionType.confirmChanged, confirm);
            }
            catch (error) {
                console.log('deliveryCharge/DeliveryChargeForm/handleClickCancel', error);
                vuexStore.dispatch(deliveryChargeActionType.setToggleForm);
                vuexStore.dispatch(deliveryChargeActionType.cancelEdit);
            }
        };
        /**
         * 폼 닫기 버튼 클릭 핸들러
         */
        const handleClickCloseForm = async () => {
            try {
                await vuexStore.dispatch(deliveryChargeActionType.confirmChanged, confirm);
            }
            catch (error) {
                console.log('deliveryCharge/DeliveryChargeForm/handleClickCloseForm', error);
                vuexStore.dispatch(deliveryChargeActionType.setToggleForm);
                vuexStore.dispatch(deliveryChargeActionType.cancelEdit);
            }
        };
        /**
         * 입력값 사전 가공
         * @param key
         * @param value
         */
        const formValuePreProcessing = (key, _value) => {
            let value = _value;
            if (key === 'specialArea') {
                return setLimitedByteTextSimple(value, validationLimitingValue.DELIVERY_CHARGE_SP_AREA_MAX_BYTE);
            }
            // 빈값일 때 0으로 나와야 하는 항목들 + number로 저장
            if (key === 'charge'
                || key === 'surcharge'
                || key === 'distanceStart'
                || key === 'distanceEnd') {
                value = value === '' ? '0' : value;
            }
            if (key === 'addressJibunStart'
                || key === 'addressJibunEnd') {
                value = value === '' ? 0 : Number(value);
            }
            return value;
        };
        /**
         * state의 formData를 이용해 key 값을 특정한다.
         */
        const getFormValue = (key) => vuexStore.state.deliveryChargeDialog.formData[key];
        const setFormValue = async (key, _value) => {
            const value = _value instanceof FocusEvent
                ? _value.target.value
                : _value;
            await vuexStore.dispatch(deliveryChargeActionType.updateFormData, {
                key,
                value: formValuePreProcessing(key, value),
            });
            // 멀티인풋 채크:: 거리
            if ([
                'distanceStart',
                'distanceEnd',
            ].includes(key)) {
                distanceOrder.value = Number(formData.value.distanceStart) > Number(formData.value.distanceEnd)
                    ? true : undefined;
                return;
            }
            // 멀티인풋 채크:: 지번
            if ([
                'addressJibunEnd',
                'addressJibunStart',
            ].includes(key)) {
                addressJibunOrder.value = formData.value.addressJibunStart > formData.value.addressJibunEnd
                    ? true : undefined;
            }
        };
        const addCommaValue = async (key, value) => {
            const v = addComma(value);
            setFormValue(key, v);
        };
        const deleteCommaValue = async (key, _value) => {
            const v = deleteComma(_value);
            setFormValue(key, v);
        };
        /**
         * 구역선택 다이얼로그로 선택한 값으로 form 업데이트
         */
        watch(() => vuexStore.state.deliveryChargeDialog.selectedArea, (value) => {
            if (!value) {
                return;
            }
            setFormValue('areaId', value.areaId);
            setFormValue('areaName', value.areaName);
        });
        /**
         * 구분 변경시 resetValidate
         */
        watch(() => vuexStore.state.deliveryChargeDialog.formData.type, () => {
            formRef.value.resetValidation();
        });
        const unsubscribe = vuexStore.subscribe(async (mutation) => {
            if (mutation.type === deliveryChargeMutationType.RESET_FORM_VALIDATION) {
                await nextTick();
                formRef.value.resetValidation();
                distanceOrder.value = undefined;
                addressJibunOrder.value = undefined;
            }
        });
        onUnmounted(() => {
            unsubscribe();
        });
        return (_ctx, _cache) => {
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_radio = _resolveComponent("v-radio");
            const _component_v_radio_group = _resolveComponent("v-radio-group");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_checkbox_btn = _resolveComponent("v-checkbox-btn");
            const _component_v_input = _resolveComponent("v-input");
            const _component_vue_datepicker_action_row = _resolveComponent("vue-datepicker-action-row");
            const _component_vue_datepicker = _resolveComponent("vue-datepicker");
            const _component_v_divider = _resolveComponent("v-divider");
            const _component_v_form = _resolveComponent("v-form");
            const _directive_btn_style = _resolveDirective("btn-style");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_v_btn, {
                    icon: "mdi-close",
                    size: "30",
                    variant: "text",
                    class: "btn-close",
                    onClick: handleClickCloseForm
                }),
                _createVNode(_component_v_form, {
                    ref_key: "formRef",
                    ref: formRef,
                    onSubmit: _withModifiers(handleSubmitForm, ["prevent"])
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                            (isEdit.value)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createVNode(_component_v_icon, null, {
                                        default: _withCtx(() => _cache[18] || (_cache[18] = [
                                            _createTextVNode(" mdi-pencil-outline ")
                                        ])),
                                        _: 1 /* STABLE */,
                                        __: [18]
                                    }),
                                    _createTextVNode(" " + _toDisplayString(_unref(lc)('form_area.title[1]', [selectedItem.value.id])), 1 /* TEXT */)
                                ], 64 /* STABLE_FRAGMENT */))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createVNode(_component_v_icon, null, {
                                        default: _withCtx(() => _cache[19] || (_cache[19] = [
                                            _createTextVNode(" mdi-plus ")
                                        ])),
                                        _: 1 /* STABLE */,
                                        __: [19]
                                    }),
                                    _createTextVNode(" " + _toDisplayString(_unref(lc)('form_area.title[0]')), 1 /* TEXT */)
                                ], 64 /* STABLE_FRAGMENT */))
                        ]),
                        _createCommentVNode(" 상점명 "),
                        _createCommentVNode(" <InputRow\n        :label=\"lc('form_area.store_name')\"\n        is-vertical-label\n      >\n        <v-text-field\n          disabled\n          density=\"comfortable\"\n          variant=\"outlined\"\n          hide-details=\"auto\"\n          :model-value=\"getFormValue('storeName')\"\n        ></v-text-field>\n      </InputRow> "),
                        _createCommentVNode(" 구분 "),
                        _createVNode(InputRow, {
                            "is-vertical-label": "",
                            label: _unref(lc)('form_area.delivery_charge_type')
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_radio_group, {
                                    inline: "",
                                    name: "deliveryChargeRadio",
                                    density: "compact",
                                    "hide-details": "",
                                    "model-value": getFormValue('type'),
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => setFormValue('type', value))
                                }, {
                                    default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deliveryChargeRadio.value, (option, key) => {
                                            return (_openBlock(), _createBlock(_component_v_radio, {
                                                key: key,
                                                label: option.label,
                                                value: option.value
                                            }, null, 8 /* PROPS */, ["label", "value"]));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["model-value"])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["label"]),
                        _createCommentVNode(" 도착지(지명) "),
                        _createVNode(InputRow, {
                            label: _unref(lc)('form_area.special_area'),
                            "is-vertical-label": "",
                            "is-required": isJibunType.value
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                    density: "comfortable",
                                    variant: "outlined",
                                    "hide-details": "auto",
                                    "model-value": getFormValue('specialArea'),
                                    rules: _unref(formRule).specialArea,
                                    "validate-on": "blur",
                                    onBlur: _cache[1] || (_cache[1] = (value) => setFormValue('specialArea', value))
                                }, null, 8 /* PROPS */, ["model-value", "rules"])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["label", "is-required"]),
                        _createCommentVNode(" 요일별할증 "),
                        _createVNode(InputRow, {
                            "is-vertical-label": "",
                            "is-required": "",
                            label: _unref(lc)('form_area.working_day')
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(koWeekObject), (item, key) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: key,
                                            class: "week-checkbox__item"
                                        }, [
                                            _createTextVNode(_toDisplayString(item) + " ", 1 /* TEXT */),
                                            _createVNode(_component_v_checkbox_btn, {
                                                value: key,
                                                ripple: false,
                                                "model-value": getFormValue('workingDay'),
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = (value) => setFormValue('workingDay', value))
                                            }, null, 8 /* PROPS */, ["value", "model-value"])
                                        ]));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ]),
                                _createCommentVNode(" 요일별할증 유효성검사 필드 "),
                                _createVNode(_component_v_input, {
                                    "model-value": getFormValue('workingDay'),
                                    rules: _unref(formRule).workingDay,
                                    "hide-details": "auto"
                                }, null, 8 /* PROPS */, ["model-value", "rules"])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["label"]),
                        _createCommentVNode(" 시간 "),
                        _createVNode(InputRow, {
                            "is-vertical-label": "",
                            "is-required": "",
                            label: _unref(lc)('form_area.business_hour')
                        }, {
                            default: _withCtx(() => [
                                _createVNode(RangeInput, null, {
                                    head: _withCtx(() => [
                                        _createCommentVNode(" 시작 시간 "),
                                        _createCommentVNode(" min-time 보고 하면 됨. https://vue3datepicker.com/props/time-picker-configuration/#min-time "),
                                        _createVNode(_component_vue_datepicker, {
                                            "time-picker": "",
                                            format: "HH:mm",
                                            "model-type": "HH:mm",
                                            "model-value": getFormValue('businessHourStart'),
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = (value) => setFormValue('businessHourStart', value))
                                        }, {
                                            "action-row": _withCtx((props) => [
                                                _createVNode(_component_vue_datepicker_action_row, _mergeProps(props, { "hide-date": "" }), null, 16 /* FULL_PROPS */)
                                            ]),
                                            "dp-input": _withCtx(() => [
                                                _createVNode(_component_v_text_field, {
                                                    class: "ta-c-input",
                                                    density: "comfortable",
                                                    variant: "outlined",
                                                    readonly: "",
                                                    "bg-color": "white",
                                                    "hide-details": "",
                                                    "model-value": getFormValue('businessHourStart')
                                                }, null, 8 /* PROPS */, ["model-value"])
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["model-value"])
                                    ]),
                                    tail: _withCtx(() => [
                                        _createVNode(_component_vue_datepicker, {
                                            "time-picker": "",
                                            format: "HH:mm",
                                            "model-type": "HH:mm",
                                            "model-value": getFormValue('businessHourEnd'),
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = (value) => setFormValue('businessHourEnd', value))
                                        }, {
                                            "action-row": _withCtx((props) => [
                                                _createVNode(_component_vue_datepicker_action_row, _mergeProps(props, { "hide-date": "" }), null, 16 /* FULL_PROPS */)
                                            ]),
                                            "dp-input": _withCtx(() => [
                                                _createVNode(_component_v_text_field, {
                                                    class: "ta-c-input",
                                                    density: "comfortable",
                                                    variant: "outlined",
                                                    readonly: "",
                                                    "bg-color": "white",
                                                    "hide-details": "",
                                                    "model-value": getFormValue('businessHourEnd')
                                                }, null, 8 /* PROPS */, ["model-value"])
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["model-value"])
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["label"]),
                        _createCommentVNode(" 구분: 거리별/지명 "),
                        (getFormValue('type') === _unref(deliveryChargeTypeName).DISTANCE)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createCommentVNode(" 거리 "),
                                _createVNode(InputRow, {
                                    "is-vertical-label": "",
                                    "is-required": "",
                                    label: _unref(lc)('form_area.distance')
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(RangeInput, null, {
                                            head: _withCtx(() => [
                                                _createVNode(_component_v_text_field, {
                                                    class: "ta-c-input",
                                                    density: "comfortable",
                                                    variant: "outlined",
                                                    "hide-details": "auto",
                                                    maxlength: _unref(validationLimitingValue).DELIVERY_CHARGE_DISTANCE_LENGTH,
                                                    "validate-on": "blur",
                                                    rules: _unref(formRule).distanceStart,
                                                    error: distanceOrder.value,
                                                    oninput: "javascript: this.value = this.value.replace(/[^0-9.]/g, '');",
                                                    "model-value": getFormValue('distanceStart'),
                                                    onBlur: _cache[5] || (_cache[5] = (value) => setFormValue('distanceStart', value)),
                                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = (value) => setFormValue('distanceStart', value))
                                                }, null, 8 /* PROPS */, ["maxlength", "rules", "error", "model-value"])
                                            ]),
                                            tail: _withCtx(() => [
                                                _createVNode(_component_v_text_field, {
                                                    class: "ta-c-input",
                                                    density: "comfortable",
                                                    variant: "outlined",
                                                    "hide-details": "auto",
                                                    maxlength: _unref(validationLimitingValue).DELIVERY_CHARGE_DISTANCE_LENGTH,
                                                    oninput: "javascript: this.value = this.value.replace(/[^0-9.]/g, '');",
                                                    "validate-on": "blur",
                                                    rules: _unref(formRule).distanceEnd,
                                                    "model-value": getFormValue('distanceEnd'),
                                                    error: distanceOrder.value,
                                                    onBlur: _cache[7] || (_cache[7] = (value) => setFormValue('distanceEnd', value)),
                                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = (value) => setFormValue('distanceEnd', value))
                                                }, null, 8 /* PROPS */, ["maxlength", "rules", "model-value", "error"])
                                            ]),
                                            _: 1 /* STABLE */
                                        }),
                                        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(lc)('form_area.distance_sub_text')), 1 /* TEXT */),
                                        _withDirectives(_createElementVNode("div", _hoisted_5, [
                                            _createCommentVNode(" 다른 값 채크해서 유효성 검사 처리 "),
                                            _createVNode(_component_v_text_field, {
                                                class: "brg-input-hidden",
                                                type: "hidden",
                                                rules: _unref(formRule).distanceOrder(distanceOrder.value)
                                            }, null, 8 /* PROPS */, ["rules"]),
                                            _createTextVNode(" " + _toDisplayString(_unref(lc)('form_area.require_jibun')), 1 /* TEXT */)
                                        ], 512 /* NEED_PATCH */), [
                                            [_vShow, distanceOrder.value]
                                        ])
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["label"])
                            ], 64 /* STABLE_FRAGMENT */))
                            : _createCommentVNode("v-if", true),
                        _createCommentVNode(" 구분: 번지 "),
                        (getFormValue('type') === _unref(deliveryChargeTypeName).LOT_NUMBER_ADDRESS)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createCommentVNode(" 번지 "),
                                _createVNode(InputRow, {
                                    "is-vertical-label": "",
                                    "is-required": "",
                                    label: _unref(lc)('form_area.jibun')
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(RangeInput, null, {
                                            head: _withCtx(() => [
                                                _createVNode(_component_v_text_field, {
                                                    class: "ta-c-input",
                                                    density: "comfortable",
                                                    variant: "outlined",
                                                    "hide-details": "auto",
                                                    maxlength: _unref(validationLimitingValue).DELIVERY_CHARGE_JIBUN_LENGTH,
                                                    rules: _unref(formRule).addressJibunStart,
                                                    oninput: "javascript: this.value = this.value.replace(/[^0-9.]/g, '');",
                                                    "validate-on": "blur",
                                                    "model-value": getFormValue('addressJibunStart'),
                                                    error: addressJibunOrder.value,
                                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = (value) => setFormValue('addressJibunStart', value))
                                                }, null, 8 /* PROPS */, ["maxlength", "rules", "model-value", "error"])
                                            ]),
                                            tail: _withCtx(() => [
                                                _createVNode(_component_v_text_field, {
                                                    class: "ta-c-input",
                                                    density: "comfortable",
                                                    variant: "outlined",
                                                    "hide-details": "auto",
                                                    maxlength: _unref(validationLimitingValue).DELIVERY_CHARGE_JIBUN_LENGTH,
                                                    rules: _unref(formRule).addressJibunEnd,
                                                    oninput: "javascript: this.value = this.value.replace(/[^0-9.]/g, '');",
                                                    "validate-on": "blur",
                                                    "model-value": getFormValue('addressJibunEnd'),
                                                    error: addressJibunOrder.value,
                                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = (value) => setFormValue('addressJibunEnd', value))
                                                }, null, 8 /* PROPS */, ["maxlength", "rules", "model-value", "error"])
                                            ]),
                                            _: 1 /* STABLE */
                                        }),
                                        _withDirectives(_createElementVNode("div", _hoisted_6, [
                                            _createCommentVNode(" 다른 값 채크해서 유효성 검사 처리 "),
                                            _createVNode(_component_v_text_field, {
                                                class: "brg-input-hidden",
                                                type: "hidden",
                                                rules: _unref(formRule).addressJibunOrder(addressJibunOrder.value)
                                            }, null, 8 /* PROPS */, ["rules"]),
                                            _createTextVNode(" " + _toDisplayString(_unref(lc)('form_area.require_jibun')), 1 /* TEXT */)
                                        ], 512 /* NEED_PATCH */), [
                                            [_vShow, addressJibunOrder.value]
                                        ])
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["label"])
                            ], 64 /* STABLE_FRAGMENT */))
                            : _createCommentVNode("v-if", true),
                        _createCommentVNode(" 구분: 구역 "),
                        (getFormValue('type') === _unref(deliveryChargeTypeName).AREA)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createCommentVNode(" 지도구역지정 "),
                                _createVNode(InputRow, {
                                    "is-vertical-label": "",
                                    "is-required": "",
                                    label: _unref(lc)('form_area.area')
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_7, [
                                            _createVNode(_component_v_text_field, {
                                                readonly: "",
                                                density: "comfortable",
                                                variant: "outlined",
                                                "hide-details": "auto",
                                                "model-value": getFormValue('areaName'),
                                                rules: _unref(formRule).areaName,
                                                "onUpdate:modelValue": _cache[11] || (_cache[11] = (value) => setFormValue('areaName', value)),
                                                onClick: handleClickSelectAreaBtn
                                            }, null, 8 /* PROPS */, ["model-value", "rules"]),
                                            _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                                onClick: handleClickSelectAreaBtn,
                                                class: "ml-2"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_unref(lc)('form_area.select_area')), 1 /* TEXT */)
                                                ]),
                                                _: 1 /* STABLE */
                                            })), [
                                                [
                                                    _directive_btn_style,
                                                    void 0,
                                                    "config",
                                                    {
                                                        primary: true,
                                                        "size-l": true
                                                    }
                                                ]
                                            ])
                                        ])
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["label"])
                            ], 64 /* STABLE_FRAGMENT */))
                            : _createCommentVNode("v-if", true),
                        _createCommentVNode(" 대행료 "),
                        _createVNode(InputRow, {
                            "is-vertical-label": "",
                            "is-required": "",
                            label: _unref(lc)('form_area.charge')
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                    class: "ta-r-input",
                                    density: "comfortable",
                                    variant: "outlined",
                                    "hide-details": "auto",
                                    suffix: _unref(lcCommon)('currency'),
                                    maxlength: _unref(validationLimitingValue).DELIVERY_CHARGE_CHARGE_LENGTH,
                                    rules: _unref(formRule).charge,
                                    oninput: "javascript: this.value = this.value.replace(/[^0-9]/g, '');",
                                    "validate-on": "blur",
                                    "model-value": getFormValue('charge'),
                                    onFocus: _cache[12] || (_cache[12] = (value) => deleteCommaValue('charge', value.target.value)),
                                    onBlur: _cache[13] || (_cache[13] = (value) => addCommaValue('charge', value.target.value)),
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = (value) => setFormValue('charge', value))
                                }, null, 8 /* PROPS */, ["suffix", "maxlength", "rules", "model-value"]),
                                (getFormValue('charge') === _unref(deliveryChargeTypeName).AREA)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                        _createVNode(_component_v_checkbox_btn),
                                        _createElementVNode("span", null, _toDisplayString(_unref(lc)('form_area.distance_and_area')), 1 /* TEXT */)
                                    ]))
                                    : _createCommentVNode("v-if", true)
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["label"]),
                        _createCommentVNode(" 할증배달대행료 "),
                        _createVNode(InputRow, {
                            "is-vertical-label": "",
                            "is-required": "",
                            label: _unref(lc)('form_area.surcharge')
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                    class: "ta-r-input",
                                    density: "comfortable",
                                    variant: "outlined",
                                    "hide-details": "auto",
                                    suffix: _unref(lcCommon)('currency'),
                                    oninput: "javascript: this.value = this.value.replace(/[^0-9]/g, '');",
                                    maxlength: _unref(validationLimitingValue).DELIVERY_CHARGE_CHARGE_LENGTH,
                                    "model-value": getFormValue('surcharge'),
                                    rules: _unref(formRule).surcharge,
                                    "validate-on": "blur",
                                    onFocus: _cache[15] || (_cache[15] = (value) => deleteCommaValue('surcharge', value.target.value)),
                                    onBlur: _cache[16] || (_cache[16] = (value) => addCommaValue('surcharge', value.target.value)),
                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = (value) => setFormValue('surcharge', value))
                                }, null, 8 /* PROPS */, ["suffix", "maxlength", "model-value", "rules"]),
                                _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(lc)('form_area.surcharge_include_charge')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["label"]),
                        _createVNode(_component_v_divider, { class: "my-3" }),
                        _createVNode(InputRow, { "is-vertical-label": "" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_10, [
                                    _createCommentVNode(" 취소 (수정시에만) "),
                                    (isEdit.value)
                                        ? _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                            key: 0,
                                            class: "mr-2",
                                            onClick: handleClickCancel
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_unref(lc)('form_area.edit_cancel')), 1 /* TEXT */)
                                            ]),
                                            _: 1 /* STABLE */
                                        })), [
                                            [
                                                _directive_btn_style,
                                                void 0,
                                                "config",
                                                {
                                                    info: true,
                                                    outlined: true,
                                                    "size-l": true
                                                }
                                            ]
                                        ])
                                        : _createCommentVNode("v-if", true),
                                    _createCommentVNode(" 추가 / 수정 "),
                                    _withDirectives((_openBlock(), _createBlock(_component_v_btn, { type: "submit" }, {
                                        default: _withCtx(() => [
                                            (isEdit.value)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _createVNode(_component_v_icon, null, {
                                                        default: _withCtx(() => _cache[20] || (_cache[20] = [
                                                            _createTextVNode(" mdi-pencil-outline ")
                                                        ])),
                                                        _: 1 /* STABLE */,
                                                        __: [20]
                                                    }),
                                                    _createTextVNode(" " + _toDisplayString(_unref(lc)('form_area.edit')), 1 /* TEXT */)
                                                ], 64 /* STABLE_FRAGMENT */))
                                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    _createVNode(_component_v_icon, null, {
                                                        default: _withCtx(() => _cache[21] || (_cache[21] = [
                                                            _createTextVNode(" mdi-plus ")
                                                        ])),
                                                        _: 1 /* STABLE */,
                                                        __: [21]
                                                    }),
                                                    _createTextVNode(" " + _toDisplayString(_unref(lc)('form_area.create')), 1 /* TEXT */)
                                                ], 64 /* STABLE_FRAGMENT */))
                                        ]),
                                        _: 1 /* STABLE */
                                    })), [
                                        [
                                            _directive_btn_style,
                                            void 0,
                                            "config",
                                            {
                                                primary: true,
                                                "size-l": true
                                            }
                                        ]
                                    ])
                                ])
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }, 512 /* NEED_PATCH */),
                _createCommentVNode(" 구역설정 다이얼로그 "),
                _createVNode(DeliveryChargeAreaControl)
            ]));
        };
    }
});
